__turbopack_context__.v({
  "workspaceForm": "CreateWorkspaceView-module-scss-module__NWtuyq__workspaceForm",
  "workspaceLayout": "CreateWorkspaceView-module-scss-module__NWtuyq__workspaceLayout",
  "workspaceVisual": "CreateWorkspaceView-module-scss-module__NWtuyq__workspaceVisual",
});
